import { animate, style, transition, trigger } from '@angular/animations';
import { NgTemplateOutlet } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Toast } from '@app/models';
import { ToastService } from '@app/services';

@Component({
  selector: 'qb-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('trigger', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translate(-100%)' }),
        animate('.1s', style({ opacity: 1, transform: 'translateX(0) ' })),
      ]),
      transition(':leave', [animate('.1s', style({ opacity: 0 }))]),
    ]),
  ],
  imports: [NgTemplateOutlet],
})
export class ToastComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  items: Toast[] = [];

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.addMessage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(toast => {
      if (toast) {
        this.items.push(toast);
        if (toast.duration !== 0) {
          setTimeout(() => this.removeItem(toast.id), toast.duration);
        }
      }
    });
    this.toastService.removedMessage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(id => {
      if (id) {
        this.removeItem(id);
      }
    });
    this.toastService.clearedMessages$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.items = [];
    });
  }

  removeItem(value: number) {
    const index = this.items.findIndex(x => x.id === value);
    if (index >= 0) {
      this.items.splice(index, 1);
    }
  }
}
